import React from "react";
import ReactModal from "react-modal";
import ManualHeader from "./assets/manual-header.svg";
import ManualFooter from "./assets/manual-footer.svg";
import { IFrameFocusManager } from "@learningblocks/shared-components";
import { CloseButton } from "@learningblocks/storybook-components/lib/FullscreenModal";
import style from "./styles.module.scss";

const appElement = document.getElementById("container");
if (appElement) {
  ReactModal.setAppElement("#container");
}
/**
 * LabManualModal:
 *  - Modal window component based on react-modal package
 */
export const LabManual = ({
  isOpen,
  onClose,
  children,
  rightContent,
  closeButton,
  notebookExpanded,
  ariaLabel,
  className,
  backLabel,
  alignLeft,
}: {
  isOpen: boolean;
  children?: React.ReactNode;
  rightContent?: React.ReactNode;
  closeButton?: boolean;
  notebookExpanded?: boolean;
  ariaLabel?: string;
  className?: string;
  onClose: () => void;
  backLabel?: string;
  alignLeft?: boolean;
}) => {
  const renderCloseButton = () =>
    closeButton ? (
      <div className={style.backButton}>
        <CloseButton close={onClose} backLabel={backLabel || "Lab"} />
      </div>
    ) : null;

  const contentClass = `${style.modal_content} ${className} ${className}_content ${alignLeft ? ` ${style.alignLeft}` : ""}`;

  const overlayClass = `${style.modal_overlay} ${
    notebookExpanded ? style.notebook_expanded : null
  } ${className}_overlay`;

  // Type cast needed due to ReactModal type incompatibility with React 18+
  // See: https://github.com/reactjs/react-modal/issues/960
  const Modal = ReactModal as unknown as React.ComponentType<ReactModal.Props>;

  return (
    <Modal
      contentLabel={ariaLabel}
      className={contentClass}
      overlayClassName={overlayClass}
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
    >
      <IFrameFocusManager>
        {renderCloseButton()}
        <div className={style.manual}>
          <img src={ManualHeader} alt="" />
          <div className={style.body}>{children}</div>
          <img src={ManualFooter} className={style.footer} alt="" />
        </div>
        {rightContent && (
          <div className={style.rightContent}>{rightContent}</div>
        )}
      </IFrameFocusManager>
    </Modal>
  );
};
